import React, { Component } from 'react';

// Child Component
import FundWalletForm from './components/FundWalletForm';

import './FundWalletModal.css';

export default class FundWalletModal extends Component {
    constructor(props) {
        super(props);
        this.state={
            steps:[ {index: 1, label:'stepOne', title:'Set Amount', state: 'form-steps__step--active'},
                {index: 2, label:'stepTwo', title:'Card Details', state: 'form-steps__step--inactive'},
                {index: 3, label:'stepThree', title:'Process', state: 'form-steps__step--inactive'},
                {index: 4, label:'stepFour', title:'Complete', state: 'form-steps__step--last'}
                ],
            amount: 0,
            currentScene: 'fundwallet'
        };
        this.fundWalletForm = React.createRef();
        this.confirmationScene = React.createRef();
    }

    componentDidMount() {}

    render() {
        
        return (
            <div className="FundWalletModal">                   
                <div id="scene1">
                    <FundWalletForm 
                        ref={this.fundWalletForm}
                        {...this.props}/>
                </div>
            </div>
        )
    }
}